define("shared/components/shared/social/connect-profile", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.canConnectProfile}}
    <div ...attributes>
      {{#if (has-block)}}
        {{yield (hash connectProfile=this.connectProfile)}}
      {{else}}
        <Shared::Ui::Button
          @onClick={{(perform this.connectProfile)}}
          class="{{this.networkWrapperClass}} o--btn--lg o--btn--block {{if this.isDisabled 'is--connected'}}"
          data-test-id="button"
          type="button"
        >
          {{#if @socialProfile}}
            <i class={{this.profileIconConnectedClass}}></i>
          {{else}}
            <i class={{this.profileIconClass}}></i>
          {{/if}}
          <span class="u--p__l__xs u--ellipsis">
            {{this.buttonTitle}}
          </span>
          {{#if @socialProfile}}
            <span class="tSU--socialButton__status o--user--sm">
              <img class="o--user__avatar u--m__l__0" src={{@socialProfile.avatarUrl}} />
            </span>
          {{else}}
            {{svg-jar "add-circle" class="o--icon"}}
          {{/if}}
        </Shared::Ui::Button>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "iWNg/KCM",
    "block": "[[[41,[30,0,[\"canConnectProfile\"]],[[[1,\"  \"],[11,0],[17,1],[12],[1,\"\\n\"],[41,[48,[30,3]],[[[1,\"      \"],[18,3,[[28,[37,3],null,[[\"connectProfile\"],[[30,0,[\"connectProfile\"]]]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,4],[[16,0,[29,[[30,0,[\"networkWrapperClass\"]],\" o--btn--lg o--btn--block \",[52,[30,0,[\"isDisabled\"]],\"is--connected\"]]]],[24,\"data-test-id\",\"button\"],[24,4,\"button\"]],[[\"@onClick\"],[[28,[37,5],[[30,0,[\"connectProfile\"]]],null]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[10,\"i\"],[15,0,[30,0,[\"profileIconConnectedClass\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"i\"],[15,0,[30,0,[\"profileIconClass\"]]],[12],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[10,1],[14,0,\"u--p__l__xs u--ellipsis\"],[12],[1,\"\\n          \"],[1,[30,0,[\"buttonTitle\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[10,1],[14,0,\"tSU--socialButton__status o--user--sm\"],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--user__avatar u--m__l__0\"],[15,\"src\",[30,2,[\"avatarUrl\"]]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,6],[\"add-circle\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"&attrs\",\"@socialProfile\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"hash\",\"shared/ui/button\",\"perform\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/social/connect-profile.hbs",
    "isStrictMode": false
  });
  let ConnectProfileComponent = _exports.default = (_dec = (0, _service.inject)('social/facebook-auth'), _dec2 = (0, _service.inject)('social/connect-profiles'), (_class = class ConnectProfileComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "facebookAuth", _descriptor2, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _defineProperty(this, "profileTypeMap", {
        [_constants.SOCIAL_PROFILE_CODES.INSTAGRAM]: 'ig',
        [_constants.SOCIAL_PROFILE_CODES.TWITTER]: 'twitter',
        [_constants.SOCIAL_PROFILE_CODES.FACEBOOK]: 'facebook',
        [_constants.SOCIAL_PROFILE_CODES.LINKEDIN]: 'linkedin',
        [_constants.SOCIAL_PROFILE_CODES.PINTEREST]: 'pinterest',
        [_constants.SOCIAL_PROFILE_CODES.TIKTOK]: 'tiktok',
        [_constants.SOCIAL_PROFILE_CODES.YOUTUBE]: 'youtube',
        [_constants.SOCIAL_PROFILE_CODES.THREADS]: 'threads'
      });
      _defineProperty(this, "socialConnectButtonAttributes", {
        networkWrapperClass: `tSU--socialButton--${this.profileTypeMap[this.args.type]}`,
        buttonTitle: this.intl.t(`authorization.connect_social.connect_${this.profileTypeMap[this.args.type]}`),
        profileIconClass: `i--${this.profileTypeMap[this.args.type]}--w`,
        profileIconConnectedClass: `i--${this.profileTypeMap[this.args.type]}`
      });
      _defineProperty(this, "connectProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.connectProfiles.addSocialProfile.perform({
            selectedSocialProfileType: this.args.type,
            group: this.currentGroup,
            area: this.args.area,
            shouldRedirectToSettings: this.args.shouldRedirectToSettings,
            redirectPath: this.args.redirectPath
          });
        }
      }), null, "connectProfile", "drop"));
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get currentUser() {
      return this.auth.currentUser;
    }
    get profileName() {
      return this.args.socialProfile?.displayNickname;
    }
    get buttonTitle() {
      if (this.args.customButtonTitle) {
        return this.args.customButtonTitle;
      }
      return this.socialConnectButtonAttributes.buttonTitle;
    }
    get networkWrapperClass() {
      return this.socialConnectButtonAttributes.networkWrapperClass;
    }
    get profileIconClass() {
      return this.socialConnectButtonAttributes.profileIconClass;
    }
    get profileIconConnectedClass() {
      return this.socialConnectButtonAttributes.profileIconConnectedClass;
    }
    get canConnectProfile() {
      if (this.args.type === _constants.SOCIAL_PROFILE_CODES.THREADS) {
        return this.auth.currentAccount?.rolloutThreads;
      }
      return true;
    }
    loadFacebookSDK() {
      this.facebookAuth.loadFacebookSDK();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "loadFacebookSDK", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadFacebookSDK"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ConnectProfileComponent);
});